import {
  GET_ALL_SUBJECTS,
  GET_SUBJECT,
  GET_COURSE_SUBJECTS,
  GET_SCHOOL_SUBJECTS,
  GET_EMP_SUBJECTS,
  GET_UN_ASSIGNED_SUBJECTS,
} from 'actions/admin/subjects';

const initialState = {
  subjectData: {
    content: [],
  },
  subjectList: [],
  subject: {},
  courseSubjects: [],
  empSubjectList: [],
  unAssignedSubjectList: [],
};

export default function subjects(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_SUBJECTS:
      return { ...state, subjectData: action.subjectData };
    case GET_SUBJECT:
      return { ...state, subject: action.subject };
    case GET_COURSE_SUBJECTS:
      return { ...state, courseSubjects: action.subjects };
    case GET_SCHOOL_SUBJECTS:
      return { ...state, subjectList: action.subjects };
    case GET_EMP_SUBJECTS:
      return { ...state, empSubjectList: action.empSubjects };
    case GET_UN_ASSIGNED_SUBJECTS:
      return { ...state, unAssignedSubjectList: action.unAssignedSubjects };
    default:
      return state;
  }
}
